import React from 'react';
import PageMeta from '../components/common/PageMeta';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import EcommercePage from "../pages/ecommerce/EcommercePage";
import Footer from "../components/Home/Footer";
import IntegrationOptions from "../pages/ecommerce/IntegrationOptions";
import Benefits from "../pages/ecommerce/Benefits";

const Ecommerce = () => {
  return (
    <Layout>
      <PageMeta title='Sunlex' />
      <Navbar classOption='navbar-light' />
      <EcommercePage />
      <IntegrationOptions />
      <Benefits />
      <Footer />
    </Layout>
  );
};

export default Ecommerce;
